import styled from "@emotion/native"
import { Spacing, Text } from "."
import SynchLogo from "../assets/synch_logo_new.svg"
import { GravitationalBubbles } from "./GravitationalBubbles"
import { JSX } from "react"

type Props = {
  children: string | JSX.Element | JSX.Element[]
}

export function LogoBackground({ children }: Props) {
  return (
    <Wrapper>
      <GravitationalBubbles />
      <Container>
        <UpperTextsWrapper>
          <Spacing top={45} />
          <SynchLogo />
          <Spacing top={20} />
          <Text type="h1" fontFamily="Tobias Light">
            The New Way to Pay
          </Text>
        </UpperTextsWrapper>
        <LowerWrapper>{children}</LowerWrapper>
      </Container>
    </Wrapper>
  )
}

const Wrapper = styled.View`
  flex: 1;
  background-color: #efe7de;
`

const Container = styled.View`
  flex: 1;
  max-width: 500px;
  width: 100%;
  align-self: center;
`

const UpperTextsWrapper = styled.View`
  flex: 3;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const LowerWrapper = styled.View`
  flex: 1;
  display: flex;
`
